var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{on:{"click":_vm.goBack}},[_vm._v("Go Back")]),_vm._v(" or "),_c('span',{on:{"click":_vm.returnHome}},[_vm._v("Return Home")])])}
var staticRenderFns = []

export { render, staticRenderFns }